import React, { useState, useRef, useEffect } from "react";
import { Modal } from "antd";
import images from "../../themes/appImage";
import appconstant from "../../themes/appconstant";
import * as Yup from "yup";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import {
  addUserinCircleLoad,
  createInnerCircleLoad,
} from "../../redux/slices/inner.slice";
import { getFileType } from "../../utils/global-func";

const CreateInnerCard = ({ myid }) => {
  const dispatch = useDispatch();
  const [modal1Open, setModal1Open] = useState(false);
  const [importModalOpen, setImportModalOpen] = useState(false); // State for the import modal
  const [descriptionLength, setDescriptionLength] = useState(0);
  const fileInputRef = useRef(null);
  const innerCircleData = useSelector(
    (state) => state.InnerCircleReducer.innerCircleData
  );
  const { innerFileUploadSuccess, createInnerCircleSucceeded } = useSelector(
    (state) => state.InnerCircleReducer
  );

  useEffect(() => {
    if (innerFileUploadSuccess) {
      setImportModalOpen(false);
      if (fileInputRef.current) {
        fileInputRef.current.value = null;
      }
    } else {
      if (fileInputRef.current) {
        fileInputRef.current.value = null;
      }
    }
    if (createInnerCircleSucceeded) {
      setImportModalOpen(true);
      setModal1Open(false);
      resetFormData();
    }
  }, [innerFileUploadSuccess, createInnerCircleSucceeded]);

  const initialValues = {
    name: "",
    description: "",
    organisation: myid,
  };

  const validationSchema = Yup.object().shape({
    name: Yup.string()
      .required("Please enter name")
      .min(3, "Name must be at least 3 characters")
      .max(15, "Name must be at most 15 characters"),
    description: Yup.string()
      .required("Please enter description")
      .min(10, "Description must be at least 10 characters")
      .max(500, "Description must be at most 500 characters"),
  });

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: (values, { resetForm }) => {
      dispatch(createInnerCircleLoad(values));
    },
  });

  const resetFormData = () => {
    formik.setFieldValue("name", "");
    formik.setFieldValue("description", "");
    formik.setFieldTouched("name", false);
    formik.setFieldTouched("description", false);
  };

  const handleDescriptionChange = (event) => {
    formik.handleChange(event); // Formik's handleChange to update form state
    const { value } = event.target;
    setDescriptionLength(value.length); // Update character count dynamically
  };

  const handleClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const formData = new FormData();
      formData.append("csv", file);
      formData.append("circle", innerCircleData);
      formData.append("type", getFileType(file.type));
      formData.append("organisation", myid);
      dispatch(addUserinCircleLoad(formData));
    }
  };

  return (
    <>
      <div
        onClick={() => setModal1Open(true)}
        className="border-[1.9px] cursor-pointer border-dashed border-[#7C63A433] bg-bgpurple rounded-[10px] flex flex-col justify-center items-center"
      >
        <div className="mb-2">
          <img src={images.createCricl} alt="group-png" />
        </div>
        <div className="flex justify-center items-center gap-2">
          <div>
            <img
              src={images.add}
              alt="add-img"
              style={{ width: "16px", height: "16px", objectFit: "contain" }}
            />
          </div>
          <div className="text-sm text-purple font-semibold">
            Create Inner Circle
          </div>
        </div>
      </div>

      <Modal
        title=""
        className="modal-update"
        centered
        visible={modal1Open}
        onCancel={() => {
          resetFormData();
          setModal1Open(false);
        }}
        footer={null}
        width={600}
      >
        <div className="add-user-popup">
          <div className="modal-add-user">
            <h1>Create Inner Circle</h1>
          </div>
          <div className="description-inner-circle">
            <form onSubmit={formik.handleSubmit}>
              <div className="wrapper_line">
                <div className="form-group">
                  <label htmlFor="name">{appconstant.name}</label>
                  <input
                    id="name"
                    name="name"
                    type="text"
                    placeholder="Enter Inner circle name"
                    className={`form-control ${
                      formik.touched.name && formik.errors.name
                        ? "is-invalid"
                        : ""
                    }`}
                    value={formik.values.name}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.name && formik.errors.name ? (
                    <div className="text-red-500 text-xs mt-1">
                      {formik.errors.name}
                    </div>
                  ) : null}
                </div>
                <div className="form-group">
                  <div className="textarea-label">
                    <label htmlFor="description">
                      {appconstant.description}
                    </label>
                    <p className="text-xs text-gray-400">
                      {descriptionLength}/500
                    </p>
                  </div>
                  <textarea
                    id="description"
                    name="description"
                    rows="5"
                    cols="50"
                    className={`form-control-textarea ${
                      formik.touched.description && formik.errors.description
                        ? "is-invalid"
                        : ""
                    }`}
                    placeholder="Enter Description"
                    value={formik.values.description}
                    onChange={handleDescriptionChange}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.description && formik.errors.description ? (
                    <div className="text-red-500 text-xs">
                      {formik.errors.description}
                    </div>
                  ) : null}
                </div>
              </div>
              <div className="click-to-upload">
                <div className="create-inner-circle-btn">
                  <button type="submit">Create Inner Circle</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </Modal>

      <Modal
        title=""
        className="modal-update"
        centered
        visible={importModalOpen}
        onCancel={() => setImportModalOpen(false)}
        footer={null}
        width={600}
      >
        <div className="add-user-popup">
          <div className="modal-add-user">
            <h1>Import People to your Circle</h1>
            <div className="user-disp">
              <p>You can always Invite more People later!</p>
            </div>
          </div>
          <div className="click-to-upload">
            <div className="upload-file">
              <img src={images.fileImg} alt="back" />
              <input
                type="file"
                ref={fileInputRef}
                style={{ display: "none" }}
                accept=".csv,.xls, application/vnd.ms-excel"
                onChange={handleFileChange}
              />
              <div>
                <button onClick={handleClick}>Click here to upload</button>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default CreateInnerCard;
